<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-cg-1"
>
    <div class="cmps-cdk-flex-20">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            Period Type
        </div>
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-overflow-y-auto cmps-cdk-min-h-128p cmps-cdk-max-h-256px"
        >
            <ng-container *ngFor="let p of _state.periodTypes; let last = last">
                <button
                    type="button"
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-b-color-grey-100 cmps-cdk-border-b-solid cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-flex cmps-cdk-p-0 cmps-cdk-text-left cmps-cdk-w-100pct focus:not:focus-visible:cmps-cdk-outline-none"
                    [class.cmps-cdk-border-b-width-1p]="!last"
                    (click)="
                        _state.viewParams.periodType = p;
                        _state.viewParams.cacheDate = null;
                        _onClick()
                    "
                >
                    <div
                        class="cmps-cdk-w-4px"
                        [class.cmps-cdk-bg-color-blue-100]="
                            _state.viewParams.periodType?.id === p.id
                        "
                    ></div>
                    <div
                        class="cmps-cdk-py-0dot25 cmps-cdk-px-0dot5 cmps-cdk-flex-grow-1"
                        [class.cmps-cdk-bg-color-blue-300]="
                            _state.viewParams.periodType?.id === p.id
                        "
                        [class.cmps-cdk-font-bold]="
                            _state.viewParams.periodType?.id === p.id
                        "
                        [class.cmps-cdk-color-blue-100]="
                            _state.viewParams.periodType?.id === p.id
                        "
                    >
                        {{ p.text }}
                    </div>
                </button>
            </ng-container>
        </div>
    </div>

    <div class="cmps-cdk-flex-80">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            Date Range
        </div>
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-overflow-x-hidden cmps-cdk-overflow-y-auto cmps-cdk-h-256px cmps-cdk-max-h-256px"
        >
            <ng-container *ngIf="_state.viewParams.periodType?.id != null">
                <ng-container
                    *ngFor="
                        let cd of _state.cacheDatesMap?.[
                            _state.viewParams.periodType.id
                        ];
                        let last = last
                    "
                >
                    <button
                        type="button"
                        class="cmps-cdk-bg-color-transparent cmps-cdk-border-b-color-grey-100 cmps-cdk-border-b-solid cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-flex cmps-cdk-p-0 cmps-cdk-text-left cmps-cdk-w-100pct focus:not:focus-visible:cmps-cdk-outline-none"
                        [class.cmps-cdk-border-b-width-1p]="!last"
                        (click)="_state.viewParams.cacheDate = cd; _onClick()"
                    >
                        <div
                            class="cmps-cdk-w-4px"
                            [class.cmps-cdk-bg-color-blue-100]="
                                _state.viewParams.cacheDate === cd
                            "
                        ></div>
                        <div
                            class="cmps-cdk-py-0dot25 cmps-cdk-px-0dot5 cmps-cdk-flex-grow-1"
                            [class.cmps-cdk-bg-color-blue-300]="
                                _state.viewParams.cacheDate === cd
                            "
                            [class.cmps-cdk-font-bold]="
                                _state.viewParams.cacheDate === cd
                            "
                            [class.cmps-cdk-color-blue-100]="
                                _state.viewParams.cacheDate === cd
                            "
                        >
                            {{ cd | cmpsReportBuilderCacheDate }}
                        </div>
                    </button>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
